import React from 'react'
import TabNav from '~/components/shared/TabNav/TabNav'
import { useIsMobile } from '~/hooks/useMediaQuery'
import ButtonContainer from '~/components/shared/TabNav/ButtonContainer'
import TabButton from '~/components/shared/TabNav/TabButton'
import { PanelContainer, TabPanel } from '~/components/shared/TabNav/index'
import { useTranslation } from '~/hooks/useTranslation'
import BenefitSection from './BenefitSection'
import SelectServiceCard from './SelectServiceCard'

const getServices = (services, itemIdx, selectTabNav) => {
  const coreServices = services.core
  const strategicServices = services.strategic
  const specializedServices = services.specialized

  const item = selectTabNav[itemIdx]

  const name = item.name

  if (name === 'core_services') {
    return (
      <Services title={item.text} services={coreServices} serviceGroup="core" />
    )
  }
  if (name === 'strategic_services') {
    return (
      <Services
        title={item.text}
        services={strategicServices}
        serviceGroup="strategic"
      />
    )
  }
  if (name === 'specialized_services') {
    return (
      <Services
        title={item.text}
        services={specializedServices}
        serviceGroup="specialized"
      />
    )
  }
  if (name === 'view_all') {
    return (
      <>
        <Services
          title={selectTabNav[1].text}
          services={coreServices}
          serviceGroup="core"
        />
        <Services
          title={selectTabNav[2].text}
          services={strategicServices}
          serviceGroup="strategic"
        />
        <Services
          title={selectTabNav[3].text}
          services={specializedServices}
          serviceGroup="specialized"
        />
      </>
    )
  }
}

const SelectTabNav = ({ services, children }) => {
  const { t } = useTranslation()
  const selectTabNav = t('select_tab_nav', { returnObjects: true })

  return (
    <TabNav defaultActiveTab={'view_all'} mobileMode="dropdown">
      <TabNavButtons />
      <PanelContainer asChild>
        {selectTabNav.map((item, itemIdx) => (
          <TabPanel
            key={`select-tab-panel-${item.name}`}
            name={item.name}
            asChild
          >
            {getServices(services, itemIdx, selectTabNav)}
            {children}
          </TabPanel>
        ))}
        <div className="min-w-[472px] overflow-hidden"></div>
      </PanelContainer>
    </TabNav>
  )
}

export default SelectTabNav

const Wrapper = ({ children }) => {
  const isMobile = useIsMobile()
  if (isMobile) return children

  return (
    <div className="relative w-full overflow-x-scroll sm:static sm:overflow-auto">
      {children}
    </div>
  )
}

const TabNavButtons = () => {
  const isMobile = useIsMobile()
  const titleClass = isMobile
    ? ''
    : 'text-sm mx-0 md:mx-0 lg:mx-0 rounded-[10px] border border-solid border-mine-shaft-200 p-3'

  const { t } = useTranslation()
  const selectTabNav = t('select_tab_nav', { returnObjects: true })

  return (
    <Wrapper>
      <ButtonContainer
        carouselWrapperClass="min-h-[4.5rem] mb-8"
        className="mb-6 flex flex-row justify-between gap-5 border-0 border-transparent min-[530px]:justify-start min-[530px]:gap-8"
        buttonClass="min-w-16"
        activeDecorationClass="bg-transparent h-0"
        titleClass={titleClass}
        activeTitleClass="bg-intoo-blue-medium text-white"
      >
        {selectTabNav.map((item) => (
          <TabButton
            key={`select-tab-nav-${item.name}`}
            name={item.name}
            text={item.text}
          />
        ))}
      </ButtonContainer>
    </Wrapper>
  )
}

const Services = ({ services, title, serviceGroup }) => {
  return (
    <BenefitSection>
      <h3>{title}</h3>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {services.map((service, idx) => (
          <SelectServiceCard
            key={`${service.requestType}-${idx}`}
            {...service}
            serviceGroup={serviceGroup}
          />
        ))}
      </div>
    </BenefitSection>
  )
}
